import { AfterViewInit, Directive, ElementRef, inject, Input, OnChanges, SimpleChanges } from '@angular/core';

import { A11yBooleanInput } from '../interfaces/a11y.interfaces';
import { toBoolean } from '../utils/a11y.util';

@Directive({
  selector: '[khA11yFocusWhenCurrentPage]'
})
export class A11yFocusWhenCurrentPageDirective implements AfterViewInit, OnChanges {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private hasViewInitialized = false;

  @Input('khA11yFocusWhenCurrentPage') public isCurrent: A11yBooleanInput = false;

  public ngAfterViewInit(): void {
    this.hasViewInitialized = true;
    this.focusIfCurrent();
  }

  public ngOnChanges(_changes: SimpleChanges): void {
    this.focusIfCurrent();
  }

  private focusIfCurrent(): void {
    if (!this.hasViewInitialized || !toBoolean(this.isCurrent, true)) {
      return;
    }

    setTimeout(() => {
      this.elementRef.nativeElement.focus();
    });
  }
}
